import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Aurora } from "@/components/Aurora";
import { GoogleRating } from "@/components/GoogleRating";

export const FunnelHero = ({ product, MotionGraphic }) => {
  const [line1, line2] = product.funnel.headline;
  return (
    <section className="relative bg-[#F0EBE0] grain overflow-hidden">
      <Aurora className="z-0" intensity="subtle" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 pt-28 md:pt-40 pb-14 md:pb-20">
        <Link
          to="/products"
          data-testid="funnel-back-link"
          className="inline-flex items-center gap-2 text-sm font-medium text-[#334155] hover:text-[#29ABE2] transition-colors mb-8 md:mb-10"
        >
          <ArrowLeft size={16} /> All products
        </Link>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <p
              data-reveal
              className="inline-flex items-center gap-2 rounded-full bg-white/70 backdrop-blur border border-[#0B132B]/8 px-4 py-1.5 text-xs sm:text-sm tracking-[0.18em] uppercase text-[#0a6fc2] font-bold mb-6"
            >
              <span className="w-2 h-2 rounded-full bg-[#29ABE2]" />
              {product.tag} · {product.name}
            </p>
            <h1
              data-reveal
              data-testid="funnel-headline"
              className="font-heading font-black text-[2.75rem] leading-[0.95] sm:text-6xl lg:text-7xl xl:text-8xl tracking-tighter text-[#0B132B]"
            >
              {line1}
              <br />
              <span className="text-gradient-breeze">{line2}</span>
            </h1>
            <p data-reveal className="mt-6 md:mt-7 text-base sm:text-lg text-[#334155] font-light leading-relaxed max-w-xl">
              {product.funnel.subhead}
            </p>
            <div data-reveal className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-3">
              <GoogleRating />
              <p className="text-sm text-[#334155]/80 font-medium">
                Free · No pressure · Licensed brokers
              </p>
            </div>
          </div>
          {MotionGraphic && (
            <div data-reveal className="lg:col-span-5">
              <MotionGraphic />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
